import React from "react";
import { FaChevronLeft } from "react-icons/fa";
import { Router, Link } from "@reach/router";

export const PageLayout = ({ title, children, backPath = "../" }) => {
  return (
    <div className="flex flex-col h-screen">
      <header className="p-2 bg-black text-white min-w-full text-xl justify-center">
        <div className="flex absolute left-0 ml-3 flex font-bold items-center">
          <FaChevronLeft />
          <Link to={backPath}>Back</Link>
        </div>
        <h2>{title}</h2>
      </header>

      <div className="h-full text-left">{children}</div>
    </div>
  );
};
